module.exports = __webpack_public_path__ + "img/right2_active.6dda5c4c.svg";